import React, { useState } from 'react';
import ModalComponent from '../../common/ModalComponent/ModalComponent';
import ModalHeader from '../../common/ModalComponent/ModalHeader';
import SlidingButton from '../../common/SlidingButton/SlidingButton';
import { Spacer } from '../../common';
import styles from '../../../styles/logpost.module.css';
import AddLogPostLink from './AddLogPostLink';
import AddLogPostScreenshot from './AddLogPostScreenshot';

interface Props {
  open: boolean;
  onClose: () => void;
  creatorDetails: Record<any, any>;
  refetchLogPosts: () => any;
}

const sliderOptions = [{ value: 'Link' }, { value: 'Screenshot' }];

function AddLogPost({ onClose, open, creatorDetails, refetchLogPosts }: Props) {
  const [selectedOption, setSelectedOption] = useState('Link');

  return (
    <ModalComponent open={open} onClose={onClose}>
      <div className={styles.addLogPostContainer}>
        <ModalHeader
          icon="📁"
          title="Log Post or Story"
          subTitle="Once you save, we'll notify the brand that you have posted!"
        />
        <Spacer spacing="24px" />
        <SlidingButton options={sliderOptions} selected={selectedOption} setSelected={setSelectedOption} />
        <Spacer spacing="24px" />
        {selectedOption === 'Link' ? (
          <AddLogPostLink onClose={onClose} creatorDetails={creatorDetails} refetchLogPosts={refetchLogPosts} />
        ) : (
          <AddLogPostScreenshot creatorDetails={creatorDetails} onClose={onClose} refetchLogPosts={refetchLogPosts} />
        )}
      </div>
    </ModalComponent>
  );
}

export default AddLogPost;
